// Shared severity-tier thresholds & helpers used by the weighted-OOR
// "Severity Index" charts and drill-downs. Keep this file in sync with
// /app/backend/severity.py so the frontend legends never contradict the
// backend math.
//
// Score bands:
//   [0, MILD)          → mild     (emerald)
//   [MILD, CONCERN)    → moderate (amber)
//   [CONCERN, ∞)       → severe   (rose)
export const SEV_MILD = 10;
export const SEV_CONCERN = 30;

/** Return the hex colour for a raw severity score. */
export function severityColor(score) {
  if (score == null) return "#94A3B8";     // slate — no data
  if (score < SEV_MILD) return "#10B981";   // emerald
  if (score < SEV_CONCERN) return "#F59E0B"; // amber
  return "#F43F5E";                         // rose
}

/** Return the short human label for a severity score. */
export function severityLabel(score) {
  if (score == null) return "—";
  if (score < SEV_MILD) return "mild";
  if (score < SEV_CONCERN) return "moderate";
  return "severe";
}

/** Return { label, cls } — Tailwind class bundle for the drill-down chip. */
export function severityTierChip(score) {
  if (score == null || score === 0) {
    return { label: "clear",   cls: "bg-emerald-500/10 border-emerald-500/40 text-emerald-200" };
  }
  if (score < SEV_MILD) {
    return { label: "mild",    cls: "bg-emerald-500/10 border-emerald-500/40 text-emerald-200" };
  }
  if (score < SEV_CONCERN) {
    return { label: "moderate", cls: "bg-amber-500/10 border-amber-500/40 text-amber-200" };
  }
  return { label: "severe", cls: "bg-rose-500/10 border-rose-500/40 text-rose-200" };
}
